import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  FormControl,
  FormLabel,
  Textarea,
  ModalFooter,
  Button,
  Text,
} from "@chakra-ui/react";

const PhoneCampaignModal = ({
                              isOpen,
                              onClose,
                              onAddCampaignOpen,
                              campaignType,
                              textAreaRef,
                              customizedTemplate,
                              setCustomizedTemplate,
                              setIsConfigVisible,
                              handleFocus,
                              handleBlur,
                              isEditing,
                              setIsEditing,
                              saveCampaign
                            }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false} size={"6xl"}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Phone Message Content</ModalHeader>
        <ModalCloseButton />
        {(campaignType === 'manual') && (
          <ModalBody>
            <FormControl>
              <FormLabel>Opening Greeting from the AI when the patient answers the call</FormLabel>
              <Textarea
                ref={textAreaRef}
                value={
                  customizedTemplate?.template?.phone?.introduction_message
                    ?.text
                }
                onFocus={() =>
                  handleFocus([
                    "template",
                    "phone",
                    "introduction_message",
                    "text",
                  ])
                }
                onBlur={handleBlur}
                onChange={(e) => {
                  setCustomizedTemplate({
                    ...customizedTemplate,
                    template: {
                      ...customizedTemplate.template,
                      phone: {
                        ...customizedTemplate.template.phone,
                        introduction_message: {
                          ...customizedTemplate.template.phone
                            .introduction_message,
                          text: e.target.value,
                        },
                      },
                    },
                  });
                }}
              />
            </FormControl>
            <FormControl mt={2}>
              <FormLabel>If voicemail</FormLabel>
              <Textarea
                value={
                  customizedTemplate?.template?.phone?.voice_mail_pickup_message
                    ?.text
                }
                ref={textAreaRef}
                onFocus={() =>
                  handleFocus([
                    "template",
                    "phone",
                    "voice_mail_pickup_message",
                    "text",
                  ])
                }
                onBlur={handleBlur}
                onChange={(e) => {
                  setCustomizedTemplate({
                    ...customizedTemplate,
                    template: {
                      ...customizedTemplate.template,
                      phone: {
                        ...customizedTemplate.template.phone,
                        voice_mail_pickup_message: {
                          ...customizedTemplate.template.phone
                            .voice_mail_pickup_message,
                          text: e.target.value,
                        },
                      },
                    },
                  });
                }}
              />
            </FormControl>
          </ModalBody>  
        )}
        {(campaignType !== 'manual') && (
          <ModalBody>
          <FormControl>
            <FormLabel>Introduction</FormLabel>
            <Textarea
              ref={textAreaRef}
              value={
                customizedTemplate?.template?.phone?.introduction_message
                  ?.text
              }
              onFocus={() =>
                handleFocus([
                  "template",
                  "phone",
                  "introduction_message",
                  "text",
                ])
              }
              onBlur={handleBlur}
              onChange={(e) => {
                setCustomizedTemplate({
                  ...customizedTemplate,
                  template: {
                    ...customizedTemplate.template,
                    phone: {
                      ...customizedTemplate.template.phone,
                      introduction_message: {
                        ...customizedTemplate.template.phone
                          .introduction_message,
                        text: e.target.value,
                      },
                    },
                  },
                });
              }}
            />
          </FormControl>
          <FormControl mt={2}>
            <FormLabel>Appointment info</FormLabel>
            <Textarea
              value={
                customizedTemplate?.template?.phone
                  ?.appointment_prototype_message?.text
              }
              ref={textAreaRef}
              onFocus={() =>
                handleFocus([
                  "template",
                  "phone",
                  "appointment_prototype_message",
                  "text",
                ])
              }
              onBlur={handleBlur}
              onChange={(e) => {
                setCustomizedTemplate({
                  ...customizedTemplate,
                  template: {
                    ...customizedTemplate.template,
                    phone: {
                      ...customizedTemplate.template.phone,
                      appointment_prototype_message: {
                        ...customizedTemplate.template.phone
                          .appointment_prototype_message,
                        text: e.target.value,
                      },
                    },
                  },
                });
              }}
            />
          </FormControl>
          {customizedTemplate.settings.ai_enabled &&
            <FormControl mt={2}>
              <FormLabel>AI enabled</FormLabel>
              <Text>{customizedTemplate?.template?.phone?.ai_transfer_message?.text}</Text>
            </FormControl>}
          <FormControl mt={2}>
            <FormLabel>If answered</FormLabel>
            <Textarea
              value={
                customizedTemplate?.template?.phone?.human_pickup_message
                  ?.text
              }
              ref={textAreaRef}
              onFocus={() =>
                handleFocus(["template", "phone", "human_pickup_message", "text"])
              }
              onBlur={handleBlur}
              onChange={(e) => {
                setCustomizedTemplate({
                  ...customizedTemplate,
                  template: {
                    ...customizedTemplate.template,
                    phone: {
                      ...customizedTemplate.template.phone,
                      human_pickup_message: {
                        ...customizedTemplate.template.phone
                          .human_pickup_message,
                        text: e.target.value,
                      },
                    },
                  },
                });
              }}
            />
          </FormControl>
          <FormControl mt={2}>
            <FormLabel>If voicemail</FormLabel>
            <Textarea
              value={
                customizedTemplate?.template?.phone?.voice_mail_pickup_message
                  ?.text
              }
              ref={textAreaRef}
              onFocus={() =>
                handleFocus([
                  "template",
                  "phone",
                  "voice_mail_pickup_message",
                  "text",
                ])
              }
              onBlur={handleBlur}
              onChange={(e) => {
                setCustomizedTemplate({
                  ...customizedTemplate,
                  template: {
                    ...customizedTemplate.template,
                    phone: {
                      ...customizedTemplate.template.phone,
                      voice_mail_pickup_message: {
                        ...customizedTemplate.template.phone
                          .voice_mail_pickup_message,
                        text: e.target.value,
                      },
                    },
                  },
                });
              }}
            />
          </FormControl>
          <FormControl mt={2}>
            <FormLabel>Response to opt out</FormLabel>
            <Textarea
              value={
                customizedTemplate?.template?.phone?.on_opt_out_response?.text
              }
              onChange={(e) => {
                setCustomizedTemplate({
                  ...customizedTemplate,
                  template: {
                    ...customizedTemplate.template,
                    phone: {
                      ...customizedTemplate.template.phone,
                      on_opt_out_response: {
                        ...customizedTemplate.template.phone
                          .on_opt_out_response,
                        text: e.target.value,
                      },
                    },
                  },
                });
              }}
            />
          </FormControl>
          <FormControl mt={2}>
            <FormLabel>If confirmed</FormLabel>
            <Textarea
              value={
                customizedTemplate?.template?.phone?.on_confirmation_response
                  ?.text
              }
              onChange={(e) => {
                setCustomizedTemplate({
                  ...customizedTemplate,
                  template: {
                    ...customizedTemplate.template,
                    phone: {
                      ...customizedTemplate.template.phone,
                      on_confirmation_response: {
                        ...customizedTemplate.template.phone
                          .on_confirmation_response,
                        text: e.target.value,
                      },
                    },
                  },
                });
              }}
            />
          </FormControl>
        </ModalBody>
        )}
        <ModalFooter>
          <Button
            variant="ghost"
            onClick={() => {
              onClose();
              if (!isEditing) {
                onAddCampaignOpen();
              } else {
                setIsEditing(false);
              }
            }}
          >
            Back
          </Button>
          <Button
            marginLeft="10px"
            colorScheme="blue"
            mr={3}
            onClick={async () => {
              onClose();
              if (!isEditing) {
                setIsConfigVisible(true);
              } else {
                await saveCampaign();
                setIsEditing(false);
              }
            }}
          >
            Create
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default PhoneCampaignModal;
